import { PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import type { CommonProps } from '../types/CommonProps';

const Foo = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.main.primary};
    background-color: ${theme.colors.main.accent};
  `
);

// const BlueFoo = ({ children }: PropsWithChildren) => {
const BlueFoo = ({ children }: CommonProps) => {
  return <Foo> {children} </Foo>;
};

export { BlueFoo };
